import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { AccountDetails } from '../interfaces/account-details.interface';
import { UpdateFormRequest } from '../interfaces/forms/register-form.interface';
import { AccountContactDetails } from '../interfaces/account-contact-details.interface';
import { AccountContactUpdate } from '../interfaces/account-contact-update.interface';
import { AccountContactAdd } from '../interfaces/account-contact-add.interface';
import { HttpContextTokens, HttpLoggingOptions } from 'common';

const sharedUrl = '/senderidregistry/account';


@Injectable({
  providedIn: 'root',
})
export class AccountRegistrationApiService {
  private http = inject(HttpClient);

  private httpContext: HttpContext = null;

  constructor() {
    this.initialiseHttpContext();
  }

  private initialiseHttpContext(): void {
    if (this.httpContext === null) {
      this.httpContext = new HttpContext();

      var httpLoggingOptions = new HttpLoggingOptions();

      //The order creation process uses post calls to build up the information on the API/DB
      //we don't want to see a "success" popup for each of those backgroud operations
      httpLoggingOptions.setDisplaySuccess('POST', false);

      this.httpContext.set(HttpContextTokens.options, httpLoggingOptions);
    }
  }

  getRegistrationDetails$(accountId: number, includeInactiveContacts = false) {
    return this.http.get<AccountDetails>(`${sharedUrl}/${accountId}/registration/${includeInactiveContacts}`);
  }

  updateRegistrationDetails$(data: UpdateFormRequest) {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });

    return this.http.post(`${sharedUrl}/${data.accountID}/registration/update`, formData, { context: this.httpContext });
  }

  getContactDetails$(accountId: number, contactId: number) {
    return this.http.get<AccountContactDetails>(`${sharedUrl}/${accountId}/registration/contact/${contactId}`);
  }

  updateContactDetails$(data: AccountContactUpdate) {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });

    return this.http.post(`${sharedUrl}/${data.accountID}/registration/contact/${data.accountContactID}/update`, formData, { context: this.httpContext });
  }

  addContactDetails$(data: AccountContactAdd) {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });

    return this.http.post(`${sharedUrl}/${data.accountID}/registration/contact/add`, formData, { context: this.httpContext });
  }

  updateContactStatus$(accountId: number, contactId: number, active: boolean) {
    return this.http.post(`${sharedUrl}/${accountId}/registration/contact/${contactId}/activate/${active}`, {}, { context: this.httpContext });
  }

  setContactAsPrimary$(accountId: number, contactId: number) {
    return this.http.post(`${sharedUrl}/${accountId}/registration/contact/${contactId}/activate/primary`, {}, { context: this.httpContext });
  }
}
